<script setup>
import { computed, nextTick, watch } from "vue";
import { useArticleBase } from "../hooks/useArticleBase";
import SlideBtn from "./SlideBtn.vue";

const { length, idx, article, articles } = useArticleBase("character");

watch(idx, async () => {
    await nextTick(); // DOM更新が終わるのを待つ
    const contents = document.querySelector(".l-section.-character");

    contents.setAttribute("data-change", 0);
    void contents.offsetWidth; // Reflowを強制する

    setTimeout(() => {
        contents.setAttribute("data-change", 1);
    }, 100);
});

const activeArticlesLength = computed(() => {
    return articles.filter((article) => article.acf.profile).length;
});

// 安全な計算プロパティを作成
// bookingでエラーが出ないように
const cast = computed(() => {
    const castData = article?.fields?.cast || {};
    return {
        main: castData.main || "", // main がない場合は空文字を返す
        ruby: castData.ruby || "", // ruby がない場合は空文字を返す
    };
});
</script>

<template>
    <div class="character__arrows -characterbtn">
        <SlideBtn v-model="idx" :length="activeArticlesLength"></SlideBtn>
    </div>
    <div class="character__contents" :class="[article.slug]">
        <div class="character-ph">
            <div class="character-ph__sub -square">
                <img :src="'/wp/wp-content/themes/apocalypsehotel/assets/img/character/' + article.slug + '/ph_sub_square.webp'" alt="" />
            </div>
            <div class="character-ph__sub -circle">
                <img :src="'/wp/wp-content/themes/apocalypsehotel/assets/img/character/' + article.slug + '/ph_sub_circle.webp'" alt="" />
            </div>
            <div class="character-ph__sub -window" v-if="article.slug !== 'childtanuki'">
                <img :src="'/wp/wp-content/themes/apocalypsehotel/assets/img/character/' + article.slug + '/ph_sub_window.webp'" alt="" />
            </div>
            <div class="character-ph__main">
                <img :src="'/wp/wp-content/themes/apocalypsehotel/assets/img/character/' + article.slug + '/ph_main.webp'" :alt="article.title" />
            </div>
        </div>
        <div class="character__texts">
            <p class="c-text-em -black tk-dystopian character__porifile">PROFILE</p>
            <h3 class="character__text__xl" v-html="article.fields.hasHtmlTitle || article.title"></h3>
            <dl class="character__col" v-if="cast.main">
                <dt class="character__text__s tk-dystopian"><span>[</span>CV<span>]</span></dt>
                <dd class="character__text__l">
                    <p v-if="cast.ruby">
                        <span :data-ruby="cast.ruby">{{ cast.main }}</span>
                    </p>
                    <p v-else>
                        {{ cast.main }}
                    </p>
                </dd>
            </dl>
            <p class="character__text" v-html="article.fields.profile"></p>
            <div class="character__block">
                <p class="c-text-em -black tk-dystopian">CHARACTER LIST</p>
                <ul class="character__lists">
                    <li class="character__list" :class="{ '-current': idx === index, '-booking': !item.acf.profile, 'c-hover_op': item.acf.profile }" v-for="(item, index) in articles" :key="index">
                        <button class="character__btn" @click="idx = index" v-if="item.acf.profile">
                            <img :src="'/wp/wp-content/themes/apocalypsehotel/assets/img/character/' + item.slug + '/thumb.webp'" alt="" />
                        </button>
                        <div v-else class="booking">
                            <img src="/wp/wp-content/themes/apocalypsehotel/assets/img/common/thumb_booking.svg" alt="" />
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
